export const TelematicAccountOperationType = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  ADD_VEHICLES: 'ADD_VEHICLES',
};
